/**
 * Composite block renderers for content-heavy marketing pages that were
 * previously rendered from hardcoded .jsx and are now block-driven via the
 * CMS. Each renderer is a thin wrapper around the paired .jsx page component
 * — the page component now accepts a `data` prop with all its externalizable
 * copy. Default values inside each page component match the 8/4/2026 baseline
 * verbatim; admins overriding fields via the CMS see their edits reflect on
 * the public site immediately.
 */
import UserGroupsPage from "@/pages/UserGroupsPage";
import ApiDocsPage from "@/pages/ApiDocsPage";
import SolutionsPage from "@/pages/SolutionsPage";
import ProductsPage from "@/pages/ProductsPage";
import ExchangePage from "@/pages/ExchangePage";
import EliteSupplierPage from "@/pages/EliteSupplierPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import AcademyPage from "@/pages/AcademyPage";
import EventsPage from "@/pages/EventsPage";
import OpenHousePage from "@/pages/OpenHousePage";
import CustomerPortalPage from "@/pages/CustomerPortalPage";

function wrap(Component) {
  return function Renderer({ data }) {
    return <Component data={data} />;
  };
}

export const UserGroupsPageBlock = wrap(UserGroupsPage);
export const ApiDocsPageBlock = wrap(ApiDocsPage);
export const SolutionsPageBlock = wrap(SolutionsPage);
export const ProductsPageBlock = wrap(ProductsPage);
export const ExchangePageBlock = wrap(ExchangePage);
export const EliteSupplierPageBlock = wrap(EliteSupplierPage);
export const IntegrationsPageBlock = wrap(IntegrationsPage);
export const AcademyPageBlock = wrap(AcademyPage);
export const EventsPageBlock = wrap(EventsPage);
export const OpenHousePageBlock = wrap(OpenHousePage);
export const CustomerPortalPageBlock = wrap(CustomerPortalPage);
